import { RootState } from 'duck/store'
import { connect } from 'react-redux'
import {
  getOrganizationFacebookUrl,
  getOrganizationLinkedinUrl,
  getOrganizationTwitterUrl,
  getOrganizationWebsiteUrl,
} from 'scenes/Dashboard/data/digitalPresences/helpers'
import {
  displayCommittedInvestors,
  displayCurrentFundingRound,
  displayRoundTerms,
  displayTargetMoney,
  displayValuationPreMoney,
} from 'scenes/Dashboard/data/fundingRounds/helpers'
import {
  displayOrganizationHeadquarters,
  displayOrganizationOperatingLocations,
} from 'scenes/Dashboard/data/locations/helpers'
import {
  commarizeCurrency,
  displayOrganizationIndustries,
  getCurrentFundingRound,
  getFormattedTotalFundingRaised,
  getFundingRoundMatchingStage,
  getLastClosedFundingRound,
  getOrganizationStage,
} from 'scenes/Dashboard/data/organizations/helpers'

import BasicOrganizationInfo, { BasicOrganizationInfoProps } from './BasicOrganizationInfo.presentational'

function mapStateToProps(state: RootState, { organization }: ContainerProps): StateProps {
  if (!organization) {
    return {}
  }

  const stage = getOrganizationStage(organization)
  const fundingRoundMatchingStage = getFundingRoundMatchingStage(organization, stage)
  const announcedDateOfCurrentStageFundingRound = fundingRoundMatchingStage
    ? fundingRoundMatchingStage.announcedOn
    : undefined

  const lastClosedFundingRound = getLastClosedFundingRound(organization.fundingRounds)
  const currentFundingRound = getCurrentFundingRound(organization)
  const totalFunding = getFormattedTotalFundingRaised(organization.fundingRounds)

  return {
    organization,
    headquarters: displayOrganizationHeadquarters(organization),
    operatingLocations: displayOrganizationOperatingLocations(organization),
    industries: displayOrganizationIndustries(organization),
    stage,
    totalFunding,
    lastFundingRound: {
      roundType:
        lastClosedFundingRound && lastClosedFundingRound.roundType ? lastClosedFundingRound.roundType : undefined,
      roundSize:
        lastClosedFundingRound && lastClosedFundingRound.roundSize
          ? commarizeCurrency(lastClosedFundingRound.roundSize)
          : undefined,
      announcedOn:
        lastClosedFundingRound && lastClosedFundingRound.announcedOn ? lastClosedFundingRound.announcedOn : undefined,
    },
    currentFundingRound: {
      currentlyRaising: displayCurrentFundingRound(currentFundingRound),
      roundTerms: displayRoundTerms(currentFundingRound),
      committedInvestors: displayCommittedInvestors(currentFundingRound),
      valuationPreMoney: displayValuationPreMoney(currentFundingRound),
      targetMoney: displayTargetMoney(currentFundingRound),
    },
    blurb: organization.description,
    foundedOn: organization.foundedOn,
    announcedDateOfCurrentStageFundingRound,
    urls: {
      website: getOrganizationWebsiteUrl(organization),
      linkedin: getOrganizationLinkedinUrl(organization),
      facebook: getOrganizationFacebookUrl(organization),
      twitter: getOrganizationTwitterUrl(organization),
    },
  }
}

type StateProps = Pick<
  BasicOrganizationInfoProps,
  | 'organization'
  | 'headquarters'
  | 'operatingLocations'
  | 'types'
  | 'industries'
  | 'stage'
  | 'totalFunding'
  | 'lastFundingRound'
  | 'lastFundingEvent'
  | 'currentFundingRound'
  | 'blurb'
  | 'foundedOn'
  | 'announcedDateOfCurrentStageFundingRound'
  | 'urls'
>

type ContainerProps = Pick<BasicOrganizationInfoProps, 'organization'>

export default connect(mapStateToProps)(BasicOrganizationInfo)
